import {ListboxInput, ListboxArrow} from '@reach/listbox'
import type {PropsWithChildren} from 'react'
import React from 'react'

import {Text} from '@helios/shared/styles/typography'

import * as s from './dropdown.styles'

type Option<TValue extends string> = {
    value: TValue
    label: string | JSX.Element
}

interface Props<TValue extends string> {
    onChange: (newValue: TValue) => void
    options: Option<TValue>[]
    triggerText?: string
    value: string
}

const Dropdown = <TValue extends string>({
    onChange,
    options,
    triggerText,
    value,
}: PropsWithChildren<Props<TValue>>) => (
    <ListboxInput value={value} onChange={onChange}>
        <s.StyledListboxButton>
            {(props) => (
                <>
                    <Text variant="heading-base" as="span">
                        {triggerText}{' '}
                        <Text variant="heading-base" as="span" color="brand">
                            {props.label}
                        </Text>
                    </Text>

                    <ListboxArrow>
                        <s.Arrow $isExpanded={props.isExpanded} />
                    </ListboxArrow>
                </>
            )}
        </s.StyledListboxButton>

        <s.StyledListboxPopover>
            <s.StyledListboxList>
                {options.map((option, i) => (
                    <s.StyledListboxOption key={`${option}-${i}`} value={option.value}>
                        <Text>{option.label}</Text>
                    </s.StyledListboxOption>
                ))}
            </s.StyledListboxList>
        </s.StyledListboxPopover>
    </ListboxInput>
)

export default Dropdown
